/** Host response display only; never operational schedule/payment authority. */
export interface HostScheduleDisplay {
  pickup: string | null;
  dropoff: string | null;
  timesCaptured: boolean;
  evidence: "parent" | "accepted_agreement" | "ambiguous" | "unavailable" | "absent" | "historical_window";
}
export interface HostSettlementDisplay {
  state: "paid" | "unresolved" | "unavailable";
  method: "transfer" | "manual" | "payout_link" | null;
  amount: number | null;
  currency: string | null;
  needsReview?: boolean;
}
export function hostHistoryMoney(row: {
  owner_earn: number | null;
  agreed_owner_earn?: number | null;
  currency?: string | null;
  hostPayoutSettlement?: HostSettlementDisplay;
}) {
  const settlement = row.hostPayoutSettlement;
  return settlement?.state === "paid"
    ? { kind: "recorded_paid" as const, amount: settlement.amount, currency: settlement.currency }
    : { kind: "agreed_earnings" as const,
      amount: row.agreed_owner_earn === undefined ? row.owner_earn : row.agreed_owner_earn,
      currency: row.currency ?? null };
}
